// extracted by mini-css-extract-plugin
export const link = "ContactLink-module--link--2hqNF";
export const offset = "ContactLink-module--offset--1Bu0J";